import { MinimalConfigurationsByConfigurationGroup } from "./getShoppingListDraftFromLockingSystemReducerState"

export const encodeConfigurationsByConfigurationGroup = (
	configurationsByConfigurationGroup: MinimalConfigurationsByConfigurationGroup,
) => {
	const encodedConfigurationsByConfigurationGroup = JSON.stringify(
		configurationsByConfigurationGroup,
	).replace(/"/g, "'")

	return encodedConfigurationsByConfigurationGroup
}

export const decodeConfigurationsByConfigurationGroup = (
	encodedConfigurationsByConfigurationGroup: string,
) => {
	const decodedConfigurationsByConfigurationGroup = JSON.parse(
		encodedConfigurationsByConfigurationGroup.replace(/'/g, '"'),
	) as MinimalConfigurationsByConfigurationGroup

	return decodedConfigurationsByConfigurationGroup
}
